import request from '@/utils/request'

// 获取账户组列表
export const getAntAccountGroupList = (params?: any) => request({
  url: '/manage/ant-product-account-group',
  method: 'get',
  params
})

// 获取账户组详情
export const getAntAccountGroupListInfo = (params: any) => request({
  url: '/manage/ant-product-account-group/' + params.id,
  method: 'get',
  params
})

// 创建账户组
export const addAntAccountGroup = (data: any) => request({
  url: '/manage/ant-product-account-group',
  method: 'post',
  data
})

// 编辑账户组
export const editAntAccountGroupList = (data: any) => request({
  url: '/manage/ant-product-account-group/' + data.id,
  method: 'patch',
  data
})

// 删除账户组
export const delAntAccountGroup = (params: any) => request({
  url: '/manage/ant-product-account-group/' + params.id,
  method: 'delete'
})